import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/footerLogo.png';

const Footer = () => {
  return (
    <footer className="site-footer">
      <img src={logo} alt="Office Outing" />
      <p>The easiest way to discover and plan unforgettable team experiences.</p>
      <div className="footer-links">
        <Link to="/">Home</Link>
        <Link to="/termsAndConditions">Terms</Link>
        <a href="mailto:meagankuhl@officeouting.org">Contact</a>
      </div>
    </footer>
  );
};

export default Footer;
